import {
  ArrowDownIcon,
  ArrowUpIcon,
  PaperAirplaneIcon,
} from "@heroicons/react/24/outline";
import React, { useEffect, useState } from "react";
import useWalletStore from "../../store/useWalletStore";
import DepositModal from "./DepositModal";
import WithdrawModal from "./WithdrawModal";
import TransferFundsModal from "./TransferFundsModal";

const WalletTransaction = () => {
  const [depositModalOpen, setDepositModalOpen] = useState(false);
  const [withdrawModalOpen, setWithdrawModalOpen] = useState(false);
  const [transferModalOpen, setTransferModalOpen] = useState(false);

  const {
    balances,
    transactions,
    fetchBalances,
    fetchWallets,
    fetchTransactions,
    isLoading,
  } = useWalletStore();

  useEffect(() => {
    const fetchData = async () => {
      try {
        await Promise.all([
          fetchBalances(),
          fetchWallets(),
          fetchTransactions(),
        ]);
      } catch (error) {
        console.error("Error fetching wallet data:", error);
      }
    };

    fetchData();
  }, [fetchBalances, fetchWallets, fetchTransactions]);

  const balancesArray = Object.values(balances || {}).map((balance) => ({
    ...balance,
    usdValue: balance.usdValue || 0,
    change24h: balance.change24h || 0,
  }));

  return (
    <div className="">
      {/* Header */}
      <div className="bg-[#2A356D] border border-blue-400 rounded-2xl  mt-2 sm:mt-4  relative overflow-hidden">
        {/* Subtle animated background pattern */}

        <div className="relative mx-auto px-4 sm:px-6 lg:px-10 py-6 sm:py-8">
          <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between">
            <div className="mb-4 sm:mb-6 lg:mb-0">
              <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold !text-whitemb-2 sm:mb-3 drop-shadow-sm">
                Wallet
              </h1>
              <p className="!text-white text-sm sm:text-base lg:text-lg font-medium">
                Manage your digital assets securely
              </p>
            </div>

            {/* Quick Actions */}
            <div className="flex flex-col sm:flex-row items-stretch sm:items-center space-y-3 sm:space-y-0 sm:space-x-4">
              <button
                onClick={() => setDepositModalOpen(true)}
                className="group flex items-center justify-center px-4 sm:px-6 py-3 bg-[#2A356D]  rounded-full transition-all duration-300   border !border-white   transform hover:scale-105"
              >
                <ArrowDownIcon className="h-4 w-4 sm:h-5 sm:w-5 mr-2 !text-whitegroup-hover:animate-bounce" />
                <span className="font-bold !text-whitetext-sm  sm:text-base">
                  Deposit
                </span>
              </button>
              <button
                onClick={() => setWithdrawModalOpen(true)}
                className="group flex items-center justify-center px-4 sm:px-6 py-3 bg-[#2A356D]  rounded-full transition-all duration-300   border !border-white   transform hover:scale-105"
              >
                <ArrowUpIcon className="h-4 w-4 sm:h-5 sm:w-5 mr-2 !text-whitegroup-hover:animate-bounce" />
                <span className="font-bold !text-whitetext-sm  sm:text-base">
                  Withdraw
                </span>
              </button>
              <button
                onClick={() => setTransferModalOpen(true)}
                className="group flex items-center justify-center px-4 sm:px-6 py-3 bg-[#2A356D]  rounded-full transition-all duration-300   border !border-white   transform hover:scale-105"
              >
                <PaperAirplaneIcon className="h-4 w-4 sm:h-5 sm:w-5 mr-2 !text-whitegroup-hover:animate-bounce" />
                <span className="font-bold !text-whitetext-sm sm:text-base">
                  Transfer
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Modals - For selected asset from API data */}
      {depositModalOpen && (
        <DepositModal
          isOpen={depositModalOpen}
          onClose={() => setDepositModalOpen(false)}
          allAssets={balancesArray}
        />
      )}

      {withdrawModalOpen && (
        <WithdrawModal
          isOpen={withdrawModalOpen}
          onClose={() => setWithdrawModalOpen(false)}
          allAssets={balancesArray}
        />
      )}

      {transferModalOpen && (
        <TransferFundsModal
          isOpen={transferModalOpen}
          onClose={() => setTransferModalOpen(false)}
          selectedCurrency="BTC1"
        />
      )}
    </div>
  );
};

export default WalletTransaction;
